import React from "react";
import Label from './LabelUtilsComponet'
import Required from './RequiredComponent'

class AttachDocument extends React.Component {
  state = {
    value: []
  }

  handlerChange = ev => {
    const files = Array.from(ev.target.files).map(f => f)
    const value = files.map(f => f.name)
    this.setState({ value });
    if (this.props.config.multiple) {
      this.props.onChange(this.props.config.variable, files)
    } else {
      this.props.onChange(this.props.config.variable, files[0])
    }
  };

  handlerFile = () => {
    this.refs.inputFile.click();
  }

  render() {
    const { config } = this.props;
    return (
      <div className={config.classContainer}>
        <Label {...config} />
        <div className="div-input-form">
          <input type="button" className={config.classInput} onClick={this.handlerFile} value={config.btnLabel} />
          <input
            onChange={this.handlerChange}
            type="file"
            ref="inputFile"
            multiple={config.multiple}
            hidden
          />
        </div>
        {this.state.value.map(f => <p className="p-filelist">{f}</p>)}
        {
          <Required {...config} msg="Seleccione un archivo" />
        }
      </div>
    );
  }
}

export default AttachDocument;
